import PricesAndPlansHero from './PricesAndPlansHero';

export default PricesAndPlansHero;
